import { render } from "./ClientUpdate.vue?vue&type=template&id=180822c6&scoped=true"
import script from "./ClientUpdate.vue?vue&type=script&lang=js"
export * from "./ClientUpdate.vue?vue&type=script&lang=js"

import "./ClientUpdate.vue?vue&type=style&index=0&id=180822c6&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180822c6"]])

export default __exports__